/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface LlmConfigurationDeleteFieldFieldIdDelete$Params {
  fieldId: number;
}

export function llmConfigurationDeleteFieldFieldIdDelete(http: HttpClient, rootUrl: string, params: LlmConfigurationDeleteFieldFieldIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, llmConfigurationDeleteFieldFieldIdDelete.PATH, 'delete');
  if (params) {
    rb.path('fieldId', params.fieldId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

llmConfigurationDeleteFieldFieldIdDelete.PATH = '/LLMConfiguration/DeleteField/{fieldId}';
